import React from 'react'
import "./maplocation.css"


function MapLocation() {
  return (
    <>
    <div className='lg:ml-36 mb-20 xl:ml-[80px] mb-[20px] sm:mt-[25px] flex flex-col items-left lg:items-start text-left lg:text-left justify-center flex-1 px-4 lg:px-0' >
    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=600&height=400&hl=en&q=23.671721 86.156242&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://piratebay-proxys.com/">Piratebay</a></div><style dangerouslySetInnerHTML={{__html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>
     </div>
    </>
    
  )
}


export default MapLocation

